function getUrlParamAll(link) {
	var url = link ? link.split('#')[0] : window.location.search;
	var urlSearchObject = {};
	if (/\?/.test(url)) {
		var urlArray = url.match(/[&\?][a-zA-Z_0-9]+=[^#&$\/]+/g);
		for (var i = 0, len = urlArray.length; i < len; i++) {
			var urlItem = urlArray[i];
			var item = urlItem.split("=");
			urlSearchObject[item[0].substr(1)] = unescape(decodeURI(item[1]));
		}
	}
	return urlSearchObject;
};

export { getUrlParamAll }
export const xxUrlParams = getUrlParamAll()
